import { createCookie } from 'react-router';
import { pick } from 'accept-language-parser';

export const langCookie = createCookie('lang');

type Language = {
  code: string;
  label: string;
  shortLabel: string;
  flag: string;
};

export const LANGUAGES: Language[] = [
  { code: 'en', label: 'English', shortLabel: 'EN', flag: '🇺🇸' },
  { code: 'ja', label: '日本語', shortLabel: '日本語', flag: '🇯🇵' },
];

export const defaultLanguage = LANGUAGES[0]!;

export const supportedCodes = LANGUAGES.map(l => l.code);

export async function getLocale(request: Request) {
  // Allow override of locale via query param
  const url = new URL(request.url);
  const queryLocale = url.searchParams.get('lang');
  if (queryLocale && supportedCodes.includes(queryLocale)) {
    return queryLocale;
  }

  // Check for 'lang' cookie first using langCookie
  const cookieLocale = await langCookie.parse(request.headers.get('Cookie'));
  let locale: string | undefined = supportedCodes.includes(cookieLocale) ? cookieLocale : undefined;
  if (!locale) {
    const header = request.headers.get('Accept-Language') || '';
    locale = pick(supportedCodes, header, { loose: true }) || defaultLanguage.code;
  }

  return locale;
}

// getContentLang returns the language for creator content while keeping platform language unchanged
export async function getContentLang(request: Request) {
  const url = new URL(request.url);
  const locale = await getLocale(request);
  const contentLang = url.searchParams.get('contentLang');
  return contentLang && supportedCodes.includes(contentLang) ? contentLang : locale;
}
